module.exports = __webpack_public_path__ + "img/zorn.389f3632.png";